import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
import { CircleCheck } from "lucide-react";
export default function ServiceAlert() {
  const locations = [{
    name: "ALBANO",
    color: "bg-[#4CAF50]",
    streets: ["Borgo Garibaldi", "Corso Matteotti (tratto)", "Via Mascagni", "Via Tacito", "Via Virgilio"],
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/albano_road_view.png"
  }, {
    name: "CECCHINA",
    color: "bg-[#F57C00]",
    streets: ["Via Montagnano", "Via Craxi", "Via Colle Nasone", "Via Lavinio"],
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/cecchina_road_view.png"
  }, {
    name: "PAVONA",
    color: "bg-[#0277BD]",
    streets: ["Via Piani di Monte Savello", "Via Trieste", "Via Casette"],
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/pavona_road_view.png"
  }, {
    name: "CANCELLIERA / LE MOLE",
    color: "bg-[#6A1B9A]",
    streets: ["Via Pantanelle", "Via della Torre", "Via delle Mole"],
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/cancelliera_road_view.png"
  }];
  return <section data-section-id="240226" id="infrastructureplanhero" className="bg-background text-foreground font-default">
      {}
      <div className="relative min-h-[600px] flex flex-col items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/roadwork_infrastructure_hero.png" alt="Lavori stradali Albano" className="w-full h-full object-cover opacity-40" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/roadwork_infrastructure_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/roadwork_infrastructure_hero.png-wvc-sizes" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/40 to-background" />
        </div>

        <div className="container relative z-10 px-4 py-20 text-center">
          <div className="inline-block bg-primary px-8 py-4 -skew-x-12 mb-6 shadow-lg">
            <h1 className="text-4xl md:text-7xl font-extrabold text-white skew-x-12 tracking-tighter">
              ALBANO CONTA
            </h1>
          </div>
          
          <h2 className="text-3xl md:text-5xl font-bold text-primary mb-4">
            È TEMPO
          </h2>
          
          <div className="bg-secondary inline-block px-6 py-2 mb-8">
            <p className="text-secondary-foreground font-bold text-lg md:text-xl tracking-wider">
              PIANO INFRASTRUTTURALE BIENNALE
            </p>
          </div>

          <div className="max-w-3xl mx-auto bg-primary p-8 rounded-lg shadow-2xl border-b-4 border-secondary">
            <div className="text-5xl md:text-8xl font-black text-white mb-2">
              4 MILIONI
            </div>
            <div className="text-xl md:text-3xl font-bold text-white/90 tracking-[0.2em] border-t border-white/20 pt-2">
              DI EURO
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="container px-4 py-16">
        <div className="text-center mb-12">
          <h3 className="text-2xl md:text-4xl font-bold text-primary uppercase tracking-tight">
            Le strade che inizieremo a rifare
          </h3>
          <div className="h-1 w-24 bg-secondary mx-auto mt-4" />
        </div>

        <div className="grid grid-cols-1 gap-8 max-w-5xl mx-auto">
          {locations.map((loc, i) => <Card key={i} data-index={i} className="overflow-hidden border-none shadow-md bg-muted/30 flex flex-col md:flex-row items-stretch">
              <div className={`w-full md:w-48 ${loc.color} flex items-center justify-center p-6 text-center`}>
                <h4 className="text-white font-black text-xl md:text-2xl leading-tight">
                  {loc.name}
                </h4>
              </div>
              
              <div className="flex-1 p-6 md:p-8 flex flex-col md:flex-row gap-8">
                <div className="flex-1">
                  <ul className="space-y-3">
                    {loc.streets.map((street, j) => <li key={j} className="flex items-start gap-3 text-foreground/80 font-medium">
                        <CircleCheck className="size-5 text-primary shrink-0 mt-0.5" />
                        <span>{street}</span>
                      </li>)}
                  </ul>
                </div>
                <div className="w-full md:w-64 h-48 md:h-auto rounded-lg overflow-hidden shadow-inner">
                  <img src={loc.image} alt={`Strade a ${loc.name}`} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" data-wvc-srcset={`${loc.image}-wvc-srcset`} data-wvc-sizes={`${loc.image}-wvc-sizes`} loading="lazy" />
                </div>
              </div>
            </Card>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-white px-12 py-8 text-xl font-bold rounded-lg shadow-xl transition-all hover:scale-105">
            <Link to="/InfrastructurePlanPage">
              SCOPRI IL PIANO COMPLETO
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="bg-muted py-12 border-t border-border">
        <div className="container px-4 flex flex-col items-center gap-8">
          <Link to="/">
            <WvcLogo className="h-12 w-auto" />
          </Link>
          <p className="text-sm text-muted-foreground font-medium">© si comunica 2026 Borelli Sindaco - Un impegno concreto per Albano Laziale</p>
        </div>
      </div>
    </section>;
}